import DocumentsApi from '../api/documents';

export default {
  namespaced: true,
  state: {
    documents: [],
    selectedDocument: null,
  },
  getters: {
    allDocuments(state) {
      return state.documents;
    },
    selectedDocument(state) {
      return state.selectedDocument;
    },
  },
  actions: {
    getDocuments(context, params) {
      return new Promise((resolve, reject) => {
        DocumentsApi.getDocuments(params)
          .then((response) => {
            context.commit('SET_DOCUMENTS', response.result);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSelectedDocument(context, documentId) {
      return new Promise((resolve, reject) => {
        DocumentsApi.getDocument(documentId)
          .then((response) => {
            context.commit('SET_SELECTED_DOCUMENT', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async setSelectedDocument(context, document) {
      await context.commit('SET_SELECTED_DOCUMENT', document);
    },
    createDocument(context, document) {
      console.log('saving document');
      return new Promise((resolve, reject) => {
        DocumentsApi.createDocument(document)
          .then((response) => {
            console.log('document created');
            context.commit('SET_SELECTED_DOCUMENT', response);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    updateDocument(context, document) {
      console.log('saving document');
      return new Promise((resolve, reject) => {
        DocumentsApi.updateDocument(document)
          .then((response) => {
            console.log('document saved');
            context.commit('SET_SELECTED_DOCUMENT', response);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    deleteDocument(context, document) {
      console.log('deleting document');
      return new Promise((resolve, reject) => {
        DocumentsApi.deleteDocument(document)
          .then((response) => {
            console.log('document deleted');
            context.commit('SET_SELECTED_DOCUMENT', null);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    SET_DOCUMENTS: (state, documents) => {
      state.documents = documents;
    },
    SET_SELECTED_DOCUMENT: (state, document) => {
      state.selectedDocument = document;
    },
  },
};
